
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import { formatDate } from "helpers/dates";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import Popconfirm from "components/Popconfirm/Popconfirm";
import MDBox from "components/MDBox";

export default function data({generations = [], editAction, deteleAction}) {

  const rows = generations.map((game) => {
    return {
        id: (
            <MDTypography display="block" style={{cursor: "pointer"}} variant="button" fontWeight="medium" onClick={() => editAction(game)}> 
                {game.id}
            </MDTypography>
        ), 
        shift: (
            <MDTypography display="block" style={{cursor: "pointer"}} variant="button" fontWeight="medium" onClick={() => editAction(game)}> 
                {formatDate(game?.shiftConf?.startDate) + ' - ' + formatDate(game?.shiftConf?.endDate)}
            </MDTypography>
        ),
        action: (
          <MDBox display="flex" gap={1}>
            <IconButton color="blue" onClick={() => editAction(game)}>
              <VisibilityIcon />
            </IconButton>
            <Popconfirm
                title="Are you sure you want to delete this Line Generation?"
                onConfirm={() => deteleAction(game)}
            >
              <IconButton color="error">
                <i className="material-icons">delete</i>
              </IconButton>
            </Popconfirm>
          </MDBox>
        ),
    };
  });

  return {
    columns: [
      { Header: "Id", accessor: "id", width: "45%", align: "left" },
      { Header: "Shift", accessor: "shift", width: "45%", align: "left" },
      { Header: "action", accessor: "action", align: "center" },
    ],

    rows: rows,
  };
}